import axios from 'axios';
import { API_URL } from '../config/api';

// Obtener token del localStorage (usar 'authToken' que es el que usa AuthContext)
const getAuthToken = () => {
	return localStorage.getItem('authToken');
};

export const authApi = {
	// Obtener estadísticas del dashboard
	getDashboardStats: async () => {
		const token = getAuthToken();
		if (!token) {
			// No lanzar error, simplemente retornar null para indicar que no hay token
			// Esto es esperado cuando el usuario no está logueado
			return null;
		}
		const { data } = await axios.get(`${API_URL}/api/auth/dashboard-stats/`, {
			headers: {
				'Authorization': `Token ${token}`
			}
		});
		return data;
	},
};
